import React, { Fragment } from 'react';
import { SearchIcon, FileTextIcon, DatabaseIcon, ClockIcon, ArrowRightIcon, MessageSquareTextIcon, SparklesIcon, UserIcon, ShieldCheckIcon, ClipboardListIcon, CreditCardIcon, BadgeCheckIcon } from 'lucide-react';
import { useLanguage } from '../../LanguageContext';
import { dxYesterday, dxTomorrow, type Bi, type YesterdayKey, type TomorrowKey } from '../../../data/digitalExperienceChallenge';
const Y_ICONS: Record<YesterdayKey, typeof SearchIcon> = {
  search: SearchIcon,
  form: FileTextIcon,
  system: DatabaseIcon,
  wait: ClockIcon
};
const T_ICONS: Record<TomorrowKey, typeof SearchIcon> = {
  ask: MessageSquareTextIcon,
  understand: SparklesIcon,
  identify: UserIcon,
  verify: ShieldCheckIcon,
  prepare: ClipboardListIcon,
  pay: CreditCardIcon,
  track: BadgeCheckIcon
};
export function JourneyShift() {
  const {
    lang
  } = useLanguage();
  const pick = (b: Bi) => lang === 'FR' ? b.fr : b.en;
  return <div className="grid grid-cols-1 xl:grid-cols-[41fr_59fr] gap-5" data-id="element-3077" data-mp="2upxz8yv4unza">
      {/* Hier — procedural, fragmented */}
      <div className="rounded-[26px] bg-white border border-[#EEF0F4] shadow-[0_18px_44px_-30px_rgba(18,26,58,0.35)] px-7 py-6" data-id="element-3078" data-mp="5b7d7w3av5sh">
        <p className="flex flex-wrap items-baseline gap-x-4 gap-y-1" data-id="element-3079" data-mp="g1sv1pjpz6i">
          <span className="font-sans text-[20px] font-medium uppercase tracking-wide text-[#121A3A]" data-id="element-3080" data-mp="ecnm1zeguzul">{pick(dxYesterday.label)}</span>
          <span className="font-sans text-[15px] text-[#4A5268]" data-id="element-3081" data-mp="3iroh8mmnifz0">{pick(dxYesterday.sub)}</span>
        </p>
        <ol className="mt-5 grid grid-cols-2 sm:flex sm:items-center gap-4 sm:gap-2" data-id="element-3082" data-mp="3dstytlslitff">
          {dxYesterday.steps.map((s, i) => {
          const Icon = Y_ICONS[s.key];
          return <Fragment key={s.key} data-id="element-3083" data-mp="3mtieekxn11uf" data-mpi={i}>
                {i > 0 && <ArrowRightIcon className="hidden sm:block w-4 h-4 shrink-0 text-[#8A90A2]" aria-hidden="true" data-id="element-3084" data-mp="3msgstmizwwyg" />}
                <li className="flex items-center gap-2.5 min-w-0 sm:flex-1" data-id="element-3085" data-mp="2z1uvoqaj4x38">
                  <span className="w-12 h-12 rounded-full bg-[#F4F5F8] flex items-center justify-center shrink-0" aria-hidden="true" data-id="element-3086" data-mp="2v1awlh6ebjeg">
                    <Icon className="w-5 h-5 text-[#121A3A]" strokeWidth={1.6} data-id="element-3087" data-mp="xzdfgkczmznz" />
                  </span>
                  <span className="font-sans text-[14px] leading-tight text-[#4A5268]" data-id="element-3088" data-mp="12y6mpv1olufp">{pick(s.label)}</span>
                </li>
              </Fragment>;
        })}
        </ol>
      </div>

      {/* Demain — continuous, intelligent */}
      <div className="rounded-[26px] bg-white border border-[#ECEBFA] shadow-[0_18px_44px_-28px_rgba(79,70,229,0.35)] px-7 py-6" data-id="element-3089" data-mp="f3nd2w15819k">
        <p className="flex flex-wrap items-baseline gap-x-4 gap-y-1" data-id="element-3090" data-mp="k1x9tb2in9xa">
          <span className="font-sans text-[20px] font-bold uppercase tracking-wide text-[#4F46E5]" data-id="element-3091" data-mp="ozqicarakg0q">{pick(dxTomorrow.label)}</span>
          <span className="font-sans text-[15px] text-[#4A5268]" data-id="element-3092" data-mp="u15yboem3wc9">{pick(dxTomorrow.sub)}</span>
        </p>
        <ol className="mt-5 grid grid-cols-4 sm:flex sm:items-start gap-y-5 gap-x-2" data-id="element-3093" data-mp="20i186oghr6df">
          {dxTomorrow.steps.map((s, i) => {
          const Icon = T_ICONS[s.key];
          return <Fragment key={s.key} data-id="element-3094" data-mp="3pz560ct0etgv" data-mpi={i}>
                {i > 0 && <ArrowRightIcon className="hidden sm:block w-4 h-4 mt-4 shrink-0 text-[#5B6478]" aria-hidden="true" data-id="element-3095" data-mp="3kxpkkjmx6kxy" />}
                <li className="flex flex-col items-center gap-2 sm:flex-1 min-w-0" data-id="element-3096" data-mp="3g5y4x45axzml">
                  <span className="w-12 h-12 rounded-full bg-[#F1F0FD] flex items-center justify-center" aria-hidden="true" data-id="element-3097" data-mp="3b8xwwnow6msu">
                    <Icon className="w-5 h-5 text-[#4F46E5]" strokeWidth={1.7} data-id="element-3098" data-mp="36ammobuoqaa3" />
                  </span>
                  <span className="font-sans text-[14px] font-medium text-[#4F46E5] text-center whitespace-nowrap" data-id="element-3099" data-mp="3266j4h8jney1">{pick(s.label)}</span>
                </li>
              </Fragment>;
        })}
        </ol>
      </div>
    </div>;
}